// extracted by mini-css-extract-plugin
export default {"wrapper":"LogoBanner_wrapper__OWCqq"};